import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { HeaderComponent } from './header/header.component';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent implements OnInit {

  constructor(
		private router: Router
	) { }

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (!(event instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0,0)
    })
  }

}
